/**
 * 決定記録の「根拠の URL」をリンクとして出す。URL が無い行は何も出さない。
 *
 * API は http(s) しか通さないが、画面でも他のスキーム（`javascript:` 等）をリンクにしない。
 * リンクの文字は URL のホスト名にする（長い URL で表が横に伸びるのを避ける）。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 決定記録の根拠の URL を、話し合った場所へ飛べるリンクとして描く
 * @graph-connects none
 */

export interface SourceLinkProps {
  /** 根拠の URL。無い・http(s) でないときは何も出さない */
  url: string | undefined;
}

/**
 * http(s) の URL から、ユーザー情報・パス・クエリを除いたホスト部分（ポート込み）を取り出す
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 根拠の URL が http(s) か判定し、リンクの文字にするホスト部分を取り出す正規表現
 * @graph-connects none
 */
const HTTP_URL_PATTERN = /^https?:\/\/([^/?#\s]+)/i;

/**
 * 根拠の URL のリンク。
 * @graph-connects none
 */
export function SourceLink({ url }: SourceLinkProps) {
  if (url === undefined || url === '') return null;
  const match = HTTP_URL_PATTERN.exec(url);
  if (match === null) return null;
  const host = match[1]?.split('@').pop();
  if (host === undefined || host === '') return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[var(--color-accent-primary)] underline break-all"
    >
      {host}
    </a>
  );
}
